var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopeX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5C2.34315 5 1 6.34315 1 8V17C1 18.6569 2.34315 20 4 20H20C21.6569 20 23 18.6569 23 17V8C23 6.34315 21.6569 5 20 5H4ZM3.0878 7.58966C3.24442 7.24201 3.59395 7 4 7H20C20.406 7 20.7555 7.24198 20.9122 7.58959L12.6246 14.2196C12.2594 14.5118 11.7405 14.5118 11.3752 14.2196L3.0878 7.58966ZM3 10.0807V17C3 17.5523 3.44772 18 4 18H20C20.5523 18 21 17.5523 21 17V10.0806L13.874 15.7814C12.7784 16.6579 11.2215 16.6579 10.1259 15.7814L3 10.0807Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeX2);
export default __webpack_public_path__ + "static/media/EnvelopeX2.c1a5b4a76f9a7bff2367af3cf6268b95.svg";
export { ForwardRef as ReactComponent };